import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initialClientid: "",
  clientid: "",
  clientname: "",
  userId: "",
  reportValue: "",
  hasMarket: "",
  passwordExpired: "",
  marginFlag: "",
  jwtToken: "",
  refreshToken: "",
  dashBoardSummaryData: [],
  dashboardAccountDataInfo: [],
  exchangeAllocationGraph: [],
  sectorAllocationGraph: [],
  top5Dividends: [],
  top5Holdings: [],
  reportClickDateDashhboard: "",
  reportClickFromDate: "",
  reportClickToDate: ""
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardData: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearDashboardData: (state) => {
      return initialState;
    },
  },
});

export const { setDashboardData, clearDashboardData } = dashboardSlice.actions;
export default dashboardSlice.reducer;
